<div class="container px-md-0">
  <div class="row">
    <div class="col-md-7">
      <app-promo-banner></app-promo-banner>
      <lib-betting-game-teaser *ngIf="league" [leagueId]="league.id"></lib-betting-game-teaser>
      <lib-ad-sponsor-banner
        *ngIf="league"
        [entityId]="league.id"
        [entityType]="entityType"
        [hideHeader]="true">
      </lib-ad-sponsor-banner>
      <router-outlet></router-outlet>
    </div>
    <div class="col-md-5 league-sidebar d-none d-md-block">
      <div class="row">
        <div class="col-12" *ngIf="league">
          <lib-league-table
            [showLeagueName]="false"
            [smallTable]="true"
            [league]="league"
            [selectedSeason]="leagueService.selectedSeason"
          ></lib-league-table>
        </div>
        <lib-ad class="col-12 mb-2"></lib-ad>
      </div>
    </div>
  </div>
</div>
